// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowUp as RawArrowUp } from "lucide-react";
export const ArrowUp = /* @__PURE__ */ createIcon(RawArrowUp, "ArrowUp", 2);
